module.exports = __webpack_public_path__ + "prod/1.42.2/img/doumi-icon.dcb83fe1.png";